import React, { useRef, useEffect, useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  ImageListItem,
  Stack,
  Grid,
} from "@mui/material";

import uiOne from "./assets/uiux/ui_1.png";
import uiTwo from "./assets/uiux/ui_2.png";
import uiThree from "./assets/uiux/ui_3.png";
import uiFour from "./assets/uiux/ui_4.png";
import uiFive from "./assets/uiux/ui_5.png";
import uiSix from "./assets/uiux/ui_7.png";
import uiEight from "./assets/uiux/ui_8.png";

import chooseUx from "./assets/uiux/choose_ux.png";
import coroparte_brand from "./assets/uiux/corporate_branchign.png";
import mobileAppDesign from "./assets/uiux/mobile_app_design.png";
import responsiveDesign from "./assets/uiux/responsive_design.png";
import usabilityTesting from "./assets/uiux/usablility_testing.png";
import websiteDeisgn from "./assets/uiux/website_design.png";

import webDevSeven from "./assets/uiux/wearable_app_design.png";

import { Divider } from "@mui/material";
import { useLocation } from "react-router-dom";

import {
  ChevronLeft,
  ChevronRight,
  FiberManualRecord,
} from "@mui/icons-material";
import Footer from "./footer";

const UIUX = () => {
  const scrollRef = useRef();
  const { pathname } = useLocation();

  const images = [uiTwo, uiThree, uiFour, uiFive, uiSix, uiEight];

  const indexRef = useRef(0);
  const [activeIndex, setActiveIndex] = useState(0);

  const scrollToIndex = (index) => {
    const width = scrollRef.current.offsetWidth;
    scrollRef.current.scrollTo({
      left: index * width,
      behavior: "smooth",
    });
    setActiveIndex(index);
  };

  const handleManualScroll = (direction) => {
    const newIndex =
      (indexRef.current + direction + images.length) % images.length;
    indexRef.current = newIndex;
    scrollToIndex(newIndex);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    const interval = setInterval(() => {
      indexRef.current = (indexRef.current + 1) % images.length;
      scrollToIndex(indexRef.current);
    }, 3000); // every 3 seconds

    return () => clearInterval(interval); // cleanup on unmount
  }, []);

  return (
    <Box>
      <Box maxWidth="100%">
        <Box
          sx={{
            position: "relative",
            minHeight: { xs: "50vh", md: "50vh" },
            backgroundImage: `url(${uiOne})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            px: 2,
            flexDirection: "column",
            textAlign: "center",
            overflow: "hidden",
          }}
        >
          {/* Blurred Overlay */}
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              backgroundColor: "rgba(0, 0, 0, 0.4)",
              backdropFilter: "blur(2px)",
              zIndex: 1,
            }}
          />

          {/* Text Content */}
          <Box sx={{ maxWidth: "auto", mb: 4, zIndex: 2 }}>
            <Typography
              variant="h3"
              gutterBottom
              sx={{ color: "white", fontWeight: 700 }}
            >
              UI/UX Solutions
            </Typography>
          </Box>
        </Box>
      </Box>

      <Grid
        container
        spacing={4}
        alignItems="top"
        justifyContent="center"
        sx={{ flexWrap: "wrap", mt: 5 }}
      >
        {/* Left: Image */}

        <Grid item sx={{ width: { xs: "100%", md: "40%" } }}>
          <Box
            sx={{
              pl: { xs: 2, md: 0 },
              pr: { xs: 2, md: 0 },
              mb: { xs: 0, md: 2 },
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                color: "orange",
                textAlign: "left",
                pb: { xs: 2, md: 2 },
              }}
            >
              UI/UX Solutions
            </Typography>
            <Typography variant="body1" paragraph>
              UI/UX solutions play a critical role in determining how users
              interact with digital products. A seamless and engaging experience
              can significantly increase user satisfaction, retention, and
              overall success. Our UI/UX approach focuses on intuitive
              navigation, clear visual hierarchy, and a deep understanding of
              user behavior to craft interfaces that feel effortless to use.
            </Typography>

            <Typography variant="body1" paragraph>
              From concept to final deployment, we ensure every touchpoint
              delivers a meaningful interaction. Our solutions are
              research-driven and creativity-focused, allowing us to design
              products that are not only visually appealing but also enhance
              functionality and performance across platforms.
            </Typography>
          </Box>
        </Grid>

        <Grid item sx={{ width: { xs: "100%", md: "35%" } }}>
          <Box
            flex={1}
            maxHeight="800px"
            overflow="auto"
            borderLeft="1px solid #ccc"
            sx={{ pl: { xs: 0, md: 2 } }}
          >
            <Box>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                sx={{
                  maxWidth: "100%",
                  mx: "auto",
                  overflow: "hidden",
                  mt: { xs: 0, md: 4 },
                }}
              >
                <IconButton onClick={() => handleManualScroll(-1)}>
                  <ChevronLeft />
                </IconButton>

                <Box
                  ref={scrollRef}
                  sx={{
                    width: { xs: "100%", md: 600 },
                    height: { xs: "100%", md: 500 },
                    display: "flex",
                    overflowX: "hidden",
                    scrollSnapType: "x mandatory",
                  }}
                >
                  {images.map((src, index) => (
                    <ImageListItem
                      key={index}
                      sx={{
                        flex: "0 0 100%",
                        scrollSnapAlign: "center",
                      }}
                    >
                      <img
                        src={src}
                        alt={`Slide ${index + 1}`}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: "16px", // Adjust as needed (e.g., 8px, 24px)
                        }}
                        loading="lazy"
                      />
                    </ImageListItem>
                  ))}
                </Box>

                <IconButton onClick={() => handleManualScroll(1)}>
                  <ChevronRight />
                </IconButton>
              </Box>

              {/* Indicators */}
              <Stack
                direction="row"
                justifyContent="center"
                mt={2}
                sx={{ mt: 5 }}
              >
                {images.map((_, index) => (
                  <IconButton
                    key={index}
                    size="small"
                    onClick={() => scrollToIndex(index)}
                  >
                    <FiberManualRecord
                      fontSize="small"
                      color={index === activeIndex ? "primary" : "disabled"}
                    />
                  </IconButton>
                ))}
              </Stack>
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Divider sx={{ my: 1, borderColor: "orange", mt: 5 }} />

      <Box sx={{ width: { xs: "100%", md: "80%" }, mx: "auto", mb: 5 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center", // centers horizontally
            px: 2,
            mt: 5,
          }}
        >
          <Box>
            <Typography
              variant="h4"
              sx={{ color: "orange", fontWeight: "bold", mb: 1 }}
            >
              Our UI and UX Design Services
            </Typography>

            <Typography variant="body1" sx={{ mb: 2 }}>
              We offer comprehensive UI and UX design services that transform
              ideas into functional and delightful experiences. Our design
              process includes user research, wireframing, prototyping, user
              interface design, and final testing to ensure every aspect aligns
              with the brand’s identity and the users’ expectations. Whether
              you're building a mobile app, web platform, or enterprise tool, we
              tailor our design strategy to your goals. Our team collaborates
              closely with developers and stakeholders, ensuring the designs are
              feasible, scalable, and impactful from both a business and user
              perspective.
            </Typography>
          </Box>
        </Box>

        {/* Centered small orange line */}
        <Divider
          sx={{
            width: 60,
            mx: "auto",
            borderBottom: "3px solid orange",
            mb: 4,
          }}
        />

        {/* Content Block: Image Left, Text Right */}
        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{ flexWrap: "wrap", pl: { xs: 2, md: 0 }, pr: { xs: 2, md: 0 } }}
        >
          {/* Left: Image */}
          <Grid item sx={{ width: { xs: "100%", md: "40%" } }}>
            <img
              src={websiteDeisgn}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>

          {/* Right: Text */}
          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Website Design
            </Typography>
            <Typography variant="body1">
              Website design is about more than just looks—it’s about user
              experience, accessibility, performance, and lead generation. We
              create engaging, fast, and conversion-focused websites that
              reflect your brand's personality while ensuring optimal usability
              across all devices. Our web design approach combines creativity
              with user psychology, ensuring every layout, color choice, and
              interaction serves a strategic purpose. Whether you need a
              corporate website or a dynamic landing page, we build solutions
              that drive engagement and deliver results.
            </Typography>
          </Grid>
        </Grid>

        <Divider
          sx={{
            width: 60,
            mx: "auto",
            borderBottom: "3px solid orange",
            mb: 4,
          }}
        />
        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{ flexWrap: "wrap", pl: { xs: 2, md: 0 }, pr: { xs: 2, md: 0 } }}
        >
          {/* Left: Image */}

          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Responsive Design
            </Typography>
            <Typography variant="body1">
              In today’s multi-device world, responsive design is essential to
              provide a seamless experience on desktops, tablets, and
              smartphones. Our responsive design approach ensures your website
              or app automatically adjusts to the user’s screen size without
              compromising layout or usability. By using fluid grids, flexible
              images, and modern CSS techniques, we create interfaces that
              remain consistent and intuitive, regardless of the device.
              Responsive design improves SEO, boosts user satisfaction, and
              increases overall engagement.
            </Typography>
          </Grid>

          <Grid item sx={{ width: { xs: "100%", md: "25%" } }}>
            <img
              src={responsiveDesign}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>
        </Grid>

        <Divider
          sx={{
            width: 60,
            mx: "auto",
            borderBottom: "3px solid orange",
            mb: 4,
          }}
        />

        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{
            flexWrap: "wrap",
            pb: { xs: 2, md: 0 },
            pl: { xs: 2, md: 0 },
            pr: { xs: 2, md: 0 },
          }}
        >
          {/* Left: Image */}
          <Grid item sx={{ width: { xs: "100%", md: "40%" } }}>
            <img
              src={mobileAppDesign}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>

          {/* Right: Text */}
          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Mobile App Design
            </Typography>
            <Typography variant="body1">
              Mobile app design requires a special focus on simplicity, speed,
              and user engagement. We design mobile interfaces that are
              intuitive, touch-friendly, and optimized for both Android and iOS
              platforms. Every element is crafted to enhance performance and
              deliver a delightful experience. From onboarding screens to
              micro-interactions, our mobile app design process is user-centric
              and detail-oriented. We prioritize ease of use, accessibility, and
              visual consistency to ensure the app feels both functional and
              enjoyable to use.
            </Typography>
          </Grid>
        </Grid>

        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{
            flexWrap: "wrap",
            mt: { xs: 0, md: 5 },
            pl: { xs: 2, md: 0 },
            pr: { xs: 2, md: 0 },
          }}
        >
          {/* Left: Image */}

          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",

                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Corporate Branding
            </Typography>
            <Typography variant="body1">
              A strong visual identity is crucial for brand recognition and
              trust. Our corporate branding services go beyond logos to include
              color palettes, typography, voice, and visual language that
              reflect your company’s values and mission. We work with you to
              create a consistent branding strategy that’s carried across all
              digital and physical platforms. From your website to your business
              cards and presentations, our goal is to ensure your brand stands
              out and leaves a lasting impression.
            </Typography>
          </Grid>

          <Grid
            item
            sx={{ width: { xs: "100%", md: "25%" }, mb: { xs: 2, md: 0 } }}
          >
            <img
              src={coroparte_brand}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>
        </Grid>

        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{
            flexWrap: "wrap",
            mt: { xs: 0, md: 5 },
            pl: { xs: 2, md: 0 },
            pr: { xs: 2, md: 0 },
          }}
        >
          {/* Left: Image */}

          <Grid item sx={{ width: { xs: "100%", md: "25%" } }}>
            <img
              src={webDevSeven}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>

          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",

                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Wearable App Design
            </Typography>
            <Typography variant="body1">
              Wearable devices like smartwatches and fitness trackers require a
              minimalist and highly functional design approach. We create
              wearable app interfaces that are easy to navigate on small screens
              while delivering real-time, meaningful data to users. Our design
              solutions for wearables prioritize responsiveness, low-latency
              interactions, and clear feedback. Whether for health, fitness,
              notifications, or productivity, we ensure your wearable app offers
              value without clutter or confusion.
            </Typography>
          </Grid>
        </Grid>

        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{
            flexWrap: "wrap",
            mt: { xs: 0, md: 5 },
            pl: { xs: 2, md: 0 },
            pr: { xs: 2, md: 0 },
          }}
        >
          {/* Left: Image */}

          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                mt: { xs: 2, md: 0 },
                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Usability Testing
            </Typography>
            <Typography variant="body1">
              Usability testing is the backbone of good UX. We conduct thorough
              testing sessions with real users to identify friction points,
              confusing elements, and areas for improvement in your digital
              product. These insights help us iterate on designs for optimal
              performance. Our process includes A/B testing, heatmaps, click
              tracking, and user feedback analysis to fine-tune the user
              experience. Usability testing ensures that what we build not only
              looks good—but works exactly the way your users expect.
            </Typography>
          </Grid>

          <Grid item sx={{ width: { xs: "100%", md: "25%" } }}>
            <img
              src={usabilityTesting}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>
        </Grid>

        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{
            flexWrap: "wrap",
            mt: { xs: 0, md: 5 },
            pl: { xs: 2, md: 0 },
            pr: { xs: 2, md: 0 },
          }}
        >
          {/* Left: Image */}

          <Grid item sx={{ width: { xs: "100%", md: "25%" } }}>
            <img
              src={chooseUx}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>

          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",

                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Why Choose Our UI/UX Solutions?
            </Typography>
            <Typography variant="body1">
              We combine creativity, data, and deep expertise to deliver UI/UX
              solutions that users love and businesses depend on. With a team of
              seasoned designers, strategists, and researchers, we turn complex
              challenges into beautifully intuitive products. Our approach
              blends form with function to deliver experiences that are both
              practical and visually stunning. What sets us apart is our
              commitment to understanding your users and your business. We don’t
              just design screens—we design journeys. Whether you're launching a
              new product or revamping an existing one, our UI/UX solutions are
              tailored to increase engagement, improve conversions, and build
              long-lasting customer relationships.
            </Typography>
          </Grid>
        </Grid>
      </Box>
      <Footer />
    </Box>
  );
};

export default UIUX;
